import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Mateo G.',
  age: 17,
  location: 'Rosario, Santa Fe',
  text: 'Antes dudaba mucho en salir a cortar centros y me quedaba clavado. Con el sistema aprendí a leer la jugada antes. Ahora juego con una confianza que no tenía, hasta mis compañeros me lo dicen.',
  initials: 'MG'
}, {
  name: 'Tomás R.',
  age: 22,
  location: 'La Plata, Buenos Aires',
  text: 'Entrenaba todos los días pero en los partidos me comía goles tontos por estar mal parado. La guía de posicionamiento me cambió la vida. Parezco más rápido solo por estar en el lugar correcto.',
  initials: 'TR'
}, {
  name: 'Joaquín V.',
  age: 19,
  location: 'Córdoba Capital',
  text: 'El tomo de mentalidad es una locura. Me hacían un gol y me venía abajo todo el partido. Ahora reseteo la cabeza al instante. Es la primera vez que siento que domino yo el arco y no la presión.',
  initials: 'JV'
}, {
  name: 'Bautista M.',
  age: 16,
  location: 'Mendoza',
  text: 'Mejoré muchísimo el juego con los pies. Antes me la daban y la reventaba por miedo a cagarla. Ahora soy una opción de pase segura para el equipo. Muy recomendado.',
  initials: 'BM'
}, {
  name: 'Lautaro F.',
  age: 24,
  location: 'Mar del Plata',
  text: 'Juego en una liga amateur muy competitiva y sentía que me faltaba un salto de calidad. Empecé a aplicar los ejercicios de reflejos y técnica y la diferencia es abismal. Vale cada peso.',
  initials: 'LF'
}];
export const Testimonials = () => {
  return <section className="py-16 md:py-20 px-4 bg-forest-950" data-id="element-126">
      <div className="max-w-6xl mx-auto" data-id="element-127">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-128">
          {TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-forest-900 border border-forest-800 p-6 rounded-xl flex flex-col" data-id="element-129">
              <div className="flex gap-1 mb-4" data-id="element-130">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} className="fill-grass-400 text-grass-400" data-id="element-131" />)}
              </div>
              <p className="text-forest-200 font-medium italic flex-grow mb-6" data-id="element-132">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-133">
                <div className="w-12 h-12 rounded-full bg-forest-800 flex items-center justify-center font-anton text-xl text-grass-400" data-id="element-134">
                  {t.initials}
                </div>
                <div data-id="element-135">
                  <p className="font-bold text-white" data-id="element-136">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-sm text-forest-400" data-id="element-137">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};